<template>
    <div class="campaign-card">
        <div class="campaign-card__header">
            <div class="campaign-card__info">
                <a href="#" class="campaign-card__title-link" @click.prevent="goToEdit" v-tippy="{
                    content: 'Нажмите для редактирования кампании',
                    theme: 'light',
                }">{{ campaign.name }}</a>
                <div class="campaign-card__meta">
                    <span class="campaign-card__id">ID: {{ campaign.hierarchical_number || campaign.id }}</span>
                    <span class="muted">{{ formatUpdated(campaign.updated_ms) }}</span>
                    <span class="muted">{{ formatPeriod(campaign.period_start, campaign.period_end) }}</span>
                </div>
                <div v-if="campaign.comment" class="campaign-card__comment" :title="campaign.comment">
                    {{ campaign.comment }}
                </div>
            </div>

            <div class="campaign-card__status">
                <span
                    :class="['status', 'status--' + normalizeStatus(campaign.status, campaign), { 'status--changeable': canChangeStatus(campaign) }]"
                    @click="canChangeStatus(campaign) ? $emit('change-status', campaign) : null"
                    :style="{ cursor: canChangeStatus(campaign) ? 'pointer' : 'default' }" v-tippy="canChangeStatus(campaign) ? {
                        content: 'Нажмите для изменения статуса',
                        theme: 'light',
                    } : null">
                    <span class="status__text">{{ statusLabel(campaign.status, campaign) }}</span>
                    <span v-if="canChangeStatus(campaign)" class="status__change-icon"></span>
                </span>
            </div>

            <div class="campaign-card__actions">
                <button class="btn btn--primary btn--icon" :disabled="!canCreateAd(campaign)"
                    @click="$emit('add-ad', campaign)" v-tippy="{
                        content: canCreateAd(campaign)
                            ? 'Добавить объявление'
                            : 'Доступно, когда есть креативы и статус минимум Reserve',
                        theme: 'light',
                    }" aria-label="Добавить"></button>


                <div class="campaign-card__expand" :aria-expanded="isExpanded ? 'true' : 'false'"
                    @click="$emit('toggle-expand')" :title="'Инвентарей: ' + frCount(campaign)">
                    <span>{{ frCount(campaign) }} инвентарей</span>
                    <img src="/images/arrow_down.svg" :class="['chevron', { 'chevron--open': isExpanded }]" alt="" />
                </div>

                <button v-if="canDeleteCampaigns" class="btn btn--danger btn--icon"
                    @click="$emit('cancel-campaign', campaign)" :disabled="isCancellingId === campaign.id" v-tippy="{
                        content: 'Удалить кампанию (скрыть из списка)',
                        theme: 'light',
                    }" aria-label="Удалить"></button>
            </div>
        </div>

        <transition name="fade">
            <div v-show="isExpanded" class="campaign__details">
                <FramesSection :frames="campaign.frames || []" />

                <CampaignAds :campaign-id="campaign.id" :ads="ads" :loading="adsLoading" :error="adsError"
                    :normalize-status="normalizeStatus" :status-label="statusLabel" :format-period="formatPeriod"
                    :day-name="dayName" :ms-to-h-m="msToHM" :can-cancel-ad="canCancelAd"
                    :is-ad-cancelling-id="isAdCancellingId" @cancel-click="$emit('cancel-ad', $event)" />
            </div>
        </transition>
    </div>
</template>

<script>
import FramesSection from '../create/FramesSection.vue';
import CampaignAds from './CampaignAds.vue';

export default {
    name: 'CampaignCard',
    components: {
        FramesSection,
        CampaignAds,
    },
    props: {
        campaign: {
            type: Object,
            required: true,
        },
        isExpanded: {
            type: Boolean,
            default: false,
        },
        ads: {
            type: Array,
            default: () => [],
        },
        adsLoading: {
            type: Boolean,
            default: false,
        },
        adsError: {
            type: String,
            default: null,
        },
        isCancellingId: {
            type: [Number, String],
            default: null,
        },
        isAdCancellingId: {
            type: [Number, String],
            default: null,
        },
        isChangingStatus: {
            type: Boolean,
            default: false,
        },
        canDeleteCampaigns: {
            type: Boolean,
            default: false,
        },
        // Functions
        normalizeStatus: {
            type: Function,
            required: true,
        },
        statusLabel: {
            type: Function,
            required: true,
        },
        formatPeriod: {
            type: Function,
            required: true,
        },
        formatUpdated: {
            type: Function,
            required: true,
        },
        dayName: {
            type: Function,
            required: true,
        },
        msToHM: {
            type: Function,
            required: true,
        },
        canCreateAd: {
            type: Function,
            required: true,
        },
        canCancelAd: {
            type: Function,
            required: true,
        },
        canChangeStatus: {
            type: Function,
            required: true,
        },
        frCount: {
            type: Function,
            required: true,
        },
    },
    methods: {
        goToEdit() {
            if (this.campaign.campaign_external_id) {
                window.location.href = `/guaranteed/campaigns/external/${this.campaign.campaign_external_id}`;
            } else {
                window.location.href = `/guaranteed/campaigns/${this.campaign.id}/edit`;
            }
        },
    },
};
</script>